import { useState } from 'react';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';
import { useIntroText } from './useIntroText';
import { useCallToActionText } from './useCallToActionText';

export const useEmailTemplate = () => {
  // Use the shared intro text hook
  const { introText, updateIntroText } = useIntroText();
  
  // Use the call-to-action text hook
  const { ctaText, updateCtaText } = useCallToActionText();
  
  const [emailConfig, setEmailConfig] = useState({
    from: 'Briefr <redaksjonen@briefr.no>',
    subject: 'Forespørsel om kommentar til nyhetsartikkel',
    intervieweeName: 'Navn Navnesen',
    question: 'Hva er konsekvensene av den siste klimarapporten for havnivåstigning i Norge?',
    context: 'Norges klimainstitutt kom nylig med en rapport som viser økning i havnivåstigning.',
    submissionUrl: 'https://briefr.no/interview-submission/example-uuid',
    baseUrl: 'https://briefr.no'
  });

  const [activeTab, setActiveTab] = useState('preview');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setEmailConfig(prev => ({ ...prev, [name]: value }));
  };

  const saveTemplate = async () => {
    try {
      // Here you would typically save the template to a database
      // For now, we'll just show a success notification
      toast.success('E-postmal lagret');
      
      // Example of saving to Supabase (if implemented)
      // const { data, error } = await supabase
      //   .from('email_templates')
      //   .upsert({ id: 'interview-request', config: emailConfig });
      
      // if (error) throw error;
    } catch (error) {
      toast.error('Kunne ikke lagre e-postmal');
      console.error('Error saving email template:', error);
    }
  };
  
  const saveIntroText = async (newText: string) => {
    try {
      updateIntroText(newText);
      return Promise.resolve();
    } catch (error) {
      console.error('Error saving intro text:', error);
      return Promise.reject(error);
    }
  };
  
  const saveCtaText = async (newText: string) => {
    try {
      updateCtaText(newText);
      return Promise.resolve();
    } catch (error) {
      console.error('Error saving CTA text:', error);
      return Promise.reject(error);
    }
  };

  return {
    emailConfig,
    activeTab,
    setActiveTab,
    handleChange,
    saveTemplate,
    introText,
    setIntroText: updateIntroText,
    saveIntroText,
    ctaText,
    setCtaText: updateCtaText,
    saveCtaText
  };
};
